import StepBase from '../stepform/StepBase';

class EvalQuestionGroup extends StepBase {
    questionCols = [];
    handleResizeTimer = null;
    mobileMode = window.matchMedia("(max-width: 768px)").matches;
    isLast = false;
    lastButton = undefined;

    constructor() {
        super();

        window.addEventListener("resize", () => {
            this.handleResize();
        });

        document.addEventListener("click", event => {
            this.lastButton = (event.target).closest?.('button, input[type="button"], input[type="submit"], input[type="image"]');
        }, true );
    }

    handleResize() {
        clearTimeout(this.scrollTimeout);
        this.handleResizeTimer = setTimeout(() => {
            if (this.mobileMode !== window.matchMedia("(max-width: 768px)").matches) {
                this.mobileMode = window.matchMedia("(max-width: 768px)").matches;
                this.render();
            }
        }, 20);
    }

    beforeMount() {
        return new Promise((resolve, reject) => {
            this.questionCols = [];
            
            if (this.props.route && this.props.route.other) {
                const { questions, isLast } = this.props.route.other;
                this.isLast = isLast || false;
                if (questions) {
                    const columnSizes = Infinity;
                    let counter = 0;

                    for (let index = 0; index < questions.length; index++) {
                        const question = questions[index];
                        if (this.questionCols[counter]) {
                            this.questionCols[counter].push(question);
                        } else {
                            this.questionCols[counter] = [question];
                        }
                        
                        // adjust the number for column sizes
                        if (this.questionCols[counter].length >= columnSizes) {
                            counter++
                        }
                    }
                }
            }

            resolve(this.questionCols)
        })
    }

    mounted() {
        this.questionCols.forEach((questionCol) => {
            questionCol.forEach((question) => {
                this.setTargetProps({
                    target: `[ref="${question.guid}"]`,
                    props: {
                        value: this.props.data[question.guid],
                        question
                    }
                })
            })
        });

        this.querySelector('[ref="form"]').addEventListener('submit', async (e) => {
            e.preventDefault();
            const input = await this.getFormData();
            const submitter = e.submitter ? e.submitter : this.lastButton;
            const submit = submitter.getAttribute('ref') == 'submit';
            let dir = 0;
            
            if (submitter.getAttribute('ref') == 'prev') dir = -1;
            if (submitter.getAttribute('ref') == 'next') dir = 1;

            this.handleForm({input, submit, dir});
        });
    }

    getFormData() {
        return new Promise((resolve, reject) => {
            const form = this.querySelector('[ref="form"]');
            const formData = new FormData(form);
            const submitObj = {};

            [...formData.entries()].forEach((entry) => {
                submitObj[entry[0]] = submitObj[entry[0]] ? [entry[1], ...submitObj[entry[0]]] : submitObj[entry[0]] = [entry[1]];
            });

            resolve(submitObj);
        })
    }

    questionTypeComponentMap(typeName) {
        switch (typeName) {
            case 'SingleSelect':
                return "eval-radio-question";
            case 'Opinion':
                return "eval-opinion-question";
            case 'Number':
                return "eval-number-question";
            case 'MultiSelect':
                return "eval-checkbox-question";
            default:
                return "eval-text-question";
        }
    }
    
    template() {
        const {alias, description} = this.props.route;
        return `
            <section class="fu-eval__group primary__bg secondary__text secondary__headlines secondary__content tertiary__links" grid="wrap">
                <header class="fu-eval__group-header" column="s-12">
                    <h3 class="fu-eval__group-headline">
                        ${alias || "Spørgsmålgruppe"}
                    </h3>
                    ${description ? `<p class="fu-eval__group-description">
                        ${description}
                    </p>` : ''}
                </header>
                <form ref="form" column="s-12">
                    <main grid="wrap">
                    ${this.wFor(this.questionCols, (questionCol) => `
                        <div class="fu-eval__group-col" column="s-12 m-6">
                            ${this.wFor(questionCol, (question) => {
                                const component = this.questionTypeComponentMap(question.type);
                                return `
                                    <${component} class="fu-eval__question" ref="${question.guid}"></${component}>
                                `;
                            })}
                        </div>
                    `)}
                    </main>
                    <footer class="fu-eval__group-footer">
                        ${this.props.index > 0 ? '<button class="fu-eval__group-btn fu-button--outlined secondary__text" type="submit" ref="prev">Tilbage</button>' : ''}                      
                        <button class="fu-eval__group-btn fu-button tertiary__bg quaternary__text" type="submit" ref="${this.isLast ? 'submit' : 'next'}">
                            ${this.isLast ? 'Indsend' : 'Næste'}
                        </button>
                    </footer>
                </form>
            </section>
        `;
    }
  }
  
  // register component
  customElements.define( 'eval-question-group', EvalQuestionGroup );
